import { render, staticRenderFns } from "./ViInboxHome.vue?vue&type=template&id=4f907e20"
import script from "./ViInboxHome.vue?vue&type=script&lang=js"
export * from "./ViInboxHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports